﻿module Illy.SafeStack.Client.Check

open System 
open Elmish
open Fable.React
open Fable.React.Props
open Fable.Core.JsInterop
open Illy.SafeStack.Client

type CustomSettings = 
    {
        RenderInline: bool
        InputGroupCSSClasses: string list
    }

module CustomSettings = 
    let defaultOptions() = 
        {
            RenderInline = false
            InputGroupCSSClasses = []
        }

type Control = 
    {
        Id: string 

        Label: string 
        Mandatory: bool 

        Error: string option
        Warning: string option 

        Checked: bool
    }

type Model = ControlState<Control, CustomSettings> 

type Msg = 
    | SetChecked of bool

let private initControl id label mandatory isChecked = 
    {
        Id = id
        
        Label = label
        Mandatory = mandatory
        
        Error = None
        Warning = None
        
        Checked = isChecked
    }

let init id label mandatory isChecked settings : Model = 
    {
        Control = initControl id label mandatory isChecked
        Settings = ControlSettings.defaultOptions
        CustomSettings = settings 
    }

let private updateControl control msg = 
    match msg with 
    | SetChecked v -> {control with Checked = v}, Cmd.none

let update msg (model: Model) =
    let m, c = updateControl model.Control msg
    {model with Control = m}, c


///checkbox by itself
let checkInput loading (model: Model) dispatch = 
    let control = model.Control
    if loading then
        jQueryUI.skeletonScreenIcon
    else
        input [ 
            Id control.Id 
            ClassName (jQueryUI.addSkeletonScreen "form-control" None loading)
            Type "checkbox"
            OnChange (fun ev -> dispatch (SetChecked !!ev.target?``checked``))
            Checked control.Checked
        ]

let private renderInline loading (model: Model) dispatch = 
    let control = model.Control
    jQueryUI.inputGroupWithClasses ("checkbox" :: model.CustomSettings.InputGroupCSSClasses) [
        checkInput loading model dispatch
        jQueryUI.label control.Id control.Label control.Error control.Warning loading
    ]

let private renderMultiLine loading (model: Model) dispatch =
    let control = model.Control
    jQueryUI.inputGroupWithClasses model.CustomSettings.InputGroupCSSClasses [
        jQueryUI.label control.Id control.Label control.Error control.Warning loading
        checkInput loading model dispatch
    ]

let check loading (model: Model) dispatch =
    if model.CustomSettings.RenderInline then renderInline loading model dispatch
    else renderMultiLine loading model dispatch
    
//utility functions
let resetValidations (model: Model) = 
    {model with 
        Control = 
            {model.Control with 
                Error = None 
                Warning = None
            }
    }

let setValidations (model: Model) errors warnings = 
    {model with 
        Control = 
            {model.Control with 
                Error = errors 
                Warning = warnings
            }
    }

let toBool (model: Model) = model.Control.Checked
